import { DefectCatalogItem } from '../contracts/availableLayers';
import { MOCK_SCANNER_DEFECTS } from './scannerCatalog.mock';
import { isScannerMockCatalogueEnabled } from './scannerMockResponses';

export function mergeScannerMockCatalogue(
  apiDefects: readonly DefectCatalogItem[],
): readonly DefectCatalogItem[] {
  if (!isScannerMockCatalogueEnabled()) {
    return apiDefects;
  }

  const bySlug = new Map<string, DefectCatalogItem>();
  for (const defect of apiDefects) {
    bySlug.set(String(defect.slug), defect);
  }
  for (const mock of MOCK_SCANNER_DEFECTS) {
    bySlug.set(String(mock.slug), mock);
  }
  return Array.from(bySlug.values());
}
